import { IAPIItem } from './IAPIItem'

export class Societe implements IAPIItem {
    public ID: number = -1;
    public Logo: string;

    public constructor(logo: string) {
        this.Logo = logo;
    }
}